<style scoped>
	.absolute.centered {
		top: auto;
		left: 0;
		right: 0;
		bottom: auto;
	}
</style>

<template>
	<button class="relative" @click="onButtonClick()" :disabled="isDisabled" :type="type">
		<span v-if="isSubmitting" class="absolute centered"><i class="fas fa-spinner fa-spin"></i></span>
		<span :class="{'invisible':isSubmitting}">{{buttonText}}</span>
	</button>
</template>

<script>
export default {
	name: 'SubmitButton',
	props: {
		buttonText: String,
		isSubmitting: Boolean,
		submittingText: String,
		isDisabled: Boolean,
		buttonType: String,
		onClick: Function
	},
	computed: {
		type() {
			return this.buttonType || 'submit';
		}
	},
	methods: {
		onButtonClick() {
			if (typeof this.onClick === 'function') {
				this.onClick();
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// ./src/components/SubmitButton.vue